import { CoreDataSecurityMonitorsAllName } from './name';
import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityMonitorsAll } from '@api/data-security';

export const getCoreDataSecurityMonitorsAllSlice = createGetAsyncSlice({
	name: CoreDataSecurityMonitorsAllName,
	receive: true,
	request: true,
	requestHandler: getDataSecurityMonitorsAll,
	retainDataOnRequest: true
});
